<template>
  <printed-form-card>
    <div>
      <div class="d-flex align-center ga-2 mb-1">
        <span class="font-weight-bold">{{ label }}</span>
        <v-menu v-if="$slots['detailed-description']" open-on-hover>
          <template #activator="{ props }">
            <v-btn
              size="small"
              density="compact"
              variant="text"
              icon="mdi-information-variant"
              v-bind="props"></v-btn>
          </template>

          <v-card width="500">
            <v-card-text>
              <slot name="detailed-description"></slot>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>

      <div v-if="$slots.description">
        <slot name="description"></slot>
      </div>

      <div v-else-if="description" class="font-size-13 text-disabled">
        {{ description }}
      </div>
    </div>

    <v-btn density="comfortable" @click="$emit('generate')"> Сформувати </v-btn>
  </printed-form-card>
</template>

<script lang="ts">
import PrintedFormCard from '../components/PrintedFormCard.vue'

export default {
  name: 'GeneratePrintedFormItem',
  components: { PrintedFormCard },
  emits: ['generate'],
  props: {
    label: {
      type: String,
    },
    description: {
      type: String,
    },
  },
}
</script>

<style scoped lang="scss"></style>
